import React, {ReactNode, useEffect, useState} from 'react';

import {getAppConfig} from 'src/app/get-app-config';
import {OktaAuthenticationEnvironment} from 'src/modules/authentication/okta-provider/okta-authentication-environment';
import {AuthenticationConfig, DEFAULT_AUTHENTICATION_CONFIG} from 'src/modules/authentication/okta-provider/typedefs';

type Props = {
    children: ReactNode,
};

export const OktaWrapper = ({children}: Props) => {
    const [authConfig, setAuthConfig] = useState<AuthenticationConfig>(DEFAULT_AUTHENTICATION_CONFIG);

    useEffect(() => {
        getAppConfig().then(({LOGIN_URL, LOGIN_CLIENT_ID}) => {
            setAuthConfig({
                config: {
                    url: LOGIN_URL,
                    clientId: LOGIN_CLIENT_ID,
                },
            });
        });
    }, []);

    return (
        <>
            {Object.keys(authConfig.config).length ? (
                <OktaAuthenticationEnvironment authConfig={authConfig}>
                    {children}
                </OktaAuthenticationEnvironment>
            ) : null}
        </>
    );
};
